import React from "react";
import "../styles/global.css";

import DavisTate from "../assets/davistate.jpg";
import Goodfellows from "../assets/goodfellows.jpg";
import HawesandCo from "../assets/hawesandco.jpg";

const LandNewHomes = () => {
  return (
    <main className="container">
      <div className="welcome-text">
        <p>
          Welcome to Land & New Homes 
        </p>
      </div>
      <div className="intro-text">
        <p>
          Our Land & New Homes team work closely with major house builders and local developers.
          <br />
          With a network of branches across South West London, Surrey, Oxfordshire, and Berkshire, we offer a wealth of knowledge and expertise in every aspect of property development.
        </p>
      </div>
      <div className="button-group">
        <div className="button-with-image">
          <a href="https://www.davistate.com/land-new-homes/developers">
            <img src={DavisTate} alt="Davis Tate" className="button-image" />
          </a>
        </div>
        <div className="button-with-image">
          <a href="https://www.goodfellows.co.uk/land-new-homes/developers">
            <img src={Goodfellows} alt="Goodfellows" className="button-image" />
          </a>
        </div>
        <div className="button-with-image">
          <a href="https://www.hawesandco.co.uk/land-and-new-homes/developers">
            <img src={HawesandCo} alt="Hawes & Co" className="button-image" />
          </a>
        </div>
      </div>
    </main>
  );
};

export default LandNewHomes;
